<template>
  <div id="app">
    <keep-alive>
    <router-view v-if="$route.meta.keepLive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepLive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
};
</script>

<style >
html,
body,
#app {
  height: 100vh;
}
#loginDiong >>>.el-dialog{
  width: 480px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue